import { type FC } from "react";
import "../../../theme";
import { Input } from "../../Input";
import type { InputSize } from "../../Input/types";
import type { InputSlotProps } from "../types";

interface SearchInputFieldProps extends InputSlotProps {
  readonly validate?: (value: string) => string | undefined;
  readonly size?: InputSize;
}

/**
 * Search-flavoured wrapper around the generic {@link Input} atom.
 *
 * Wires the combobox slot props (focus opens the dropdown, key presses drive
 * keyboard navigation) onto the shared field and exposes a clear button that
 * resets the search query.
 *
 * When used standalone (outside SearchInput), an optional `validate` function
 * can provide inline feedback: if it returns a string, that string is rendered
 * as helper text below the field.
 */
const SearchInputField: FC<SearchInputFieldProps> = ({
  value,
  onChangeText,
  onFocus,
  onKeyPress,
  placeholder,
  label,
  leftContent,
  textInputProps,
  validate,
  size,
}) => (
  <Input
    value={value}
    onChangeText={onChangeText}
    onFocus={onFocus}
    onKeyPress={onKeyPress}
    placeholder={placeholder}
    label={label}
    leftContent={leftContent}
    size={size}
    clearable
    clearAccessibilityLabel="Clear search"
    helperText={validate?.(value)}
    textInputProps={{ autoCorrect: false, autoCapitalize: "none", ...textInputProps }}
  />
);

SearchInputField.displayName = "SearchInputField";

export { SearchInputField };
